<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <!-- BOC:[error] -->
    <AError v-if="editApi.isError" :api="editApi" :callbackReset="() => (editApi.isError = false)"></AError>
    <AError v-if="linkApi.isError" :api="linkApi" :callbackReset="() => (linkApi.isError = false)"></AError>
    <!-- EOC -->
    <!-- BOC:[error] -->
    <AError v-if="api.isError" :api="api" :callbackReset="() => (api.isError = false)"></AError>
    <!-- EOC -->

    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col cols="12" sm="6">
          <h2>Link Player</h2>
        </v-col>
      </v-row>
      <v-card-title></v-card-title>
      <v-stepper elevation="0" :value="step" v-if="step < 6">
        <v-stepper-header>
          <v-stepper-step step="1" :complete="1 < step">Input</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="2 < step">Select</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="3 < step">Confirm</v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <div class="d-flex justify-center" v-if="step == 2">
        <span class="font-weight-medium">Search By </span>
        <span class="ml-1" v-if="name"><span class="font-weight-medium">Name: </span>{{ name }}</span>
        <span class="ml-2" v-if="mainInstitution"><span class="font-weight-medium">School:</span> {{ mainInstitution
          }}</span>
        <span class="ml-2" v-if="mainClassroom"><span class="font-weight-medium">Classroom in School:</span> {{
          mainClassroom }}</span>
        <span class="ml-2" v-if="moeNumber"><span class="font-weight-medium">Email Address (MOE Email):</span> {{ moeNumber }}</span>
      </div>
      <div class="d-flex align-center justify-space-around">
        <div v-if="step == 1" class="form-content text-center">
          <v-form ref="formName" v-model="valid" lazy-validation>
            <div class="text-center pt-3">
              <TextField :value="name" label="Full name" :rules="nameRules" type="text" @input="name = $event">
              </TextField>
            </div>
            <div class="text-center pt-3" v-if="institution && institution.type == 'enrichment'">
              <TextField :value="mainInstitution" label="School" type="text" @input="mainInstitution = $event">
              </TextField>
            </div>
            <div class="text-center pt-3" v-if="institution && institution.type == 'enrichment'">
              <TextField :value="mainClassroom" label="Classroom in School" type="text" @input="mainClassroom = $event">
              </TextField>
            </div>
            <div class="text-center pt-3">
              <TextField :value="moeNumber" label="Email Address (MOE Email)" :rules="moeRules" type="text"
                @input="moeNumber = $event"></TextField>
            </div>
            <!-- <div class="text-center pt-3">
              <SelectField
                :value="mochiId"
                :field="selectField"
                @input="mochiId = $event"
              ></SelectField>
            </div> -->
            <div class="text-center pt-1">
              <v-btn width="75%" :loading="editApi.isLoading" rounded color="primary" dark @click="search()">
                Search
              </v-btn>
            </div>
            <div class="text-center pt-2">
              <v-btn width="75%" rounded outlined color="primary" dark @click="$router.go(-1)">
                Cancel
              </v-btn>
            </div>
          </v-form>
        </div>
        <div v-else-if="step == 2" class="text-center" style="min-height: 265px">
          <div>
            <v-radio-group v-model="selectedStudentId" column>
              <v-row v-for="item in students" :key="item.id" class="mb-2">
                <v-col cols="12">
                  <v-card outlined class="pa-3 mx-auto" :color="item.id === selectedStudentId ? 'blue lighten-5' : 'white'
                    ">
                    <v-row align="center">
                      <v-col cols="auto">
                        <v-radio :value="item.id" color="blue" />
                      </v-col>

                      <v-col cols="auto">
                        <AAvatar :width="60" :height="60" :avatar="item.avatar" />
                      </v-col>
                      <v-col>
                        <div :class="item.name == name ? 'font-weight-bold' : 'grey--text'">
                          {{ item.name }}
                        </div>
                        <div :class="item.Institution.name == mainInstitution ? 'font-weight-bold' : 'grey--text'">
                          {{ item.Institution.name }}
                        </div>
                        <div :class="item.Classroom.name == mainClassroom ? 'font-weight-bold' : 'grey--text'">
                          {{ item.Classroom.name }}
                        </div>
                        <div :class="item.moeNumber == moeNumber ? 'font-weight-bold' : 'grey--text'">
                          {{ item.moeNumber || '-' }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-radio-group>
          </div>
          <div class="text-center pt-1">
            <v-btn width="75%" rounded color="primary" dark @click="next()">
              Link
            </v-btn>
          </div>
          <div class="text-center pt-2">
            <v-btn width="75%" rounded outlined color="primary" dark @click="back">
              Back
            </v-btn>
          </div>
        </div>
        <div v-else-if="step == 3">
          <v-card class="mb-2">
            <v-card-title>My Student</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>Name</v-col>
                <v-col>{{ student.name || "-" }}</v-col>
              </v-row>
              <v-row>
                <v-col>School</v-col>
                <v-col>{{ mainInstitution || "-" }}</v-col>
              </v-row>
              <v-row>
                <v-col>Classroom</v-col>
                <v-col>{{ mainClassroom || "-" }}</v-col>
              </v-row>
              <v-row>
                <v-col>Email Address (MOE Email)</v-col>
                <v-col>{{ moeNumber || "-" }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="mb-2">
            <v-card-title>Linking Account</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>Name</v-col>
                <v-col>{{ selectedStudent.name || "-" }}</v-col>
              </v-row>
              <v-row>
                <v-col>School</v-col>
                <v-col>{{ selectedStudent.Institution.name || "-" }}</v-col>
              </v-row>
              <v-row>
                <v-col>Classroom</v-col>
                <v-col>{{ selectedStudent.Classroom.name || "-" }}</v-col>
              </v-row>
              <v-row>
                <v-col>Email Address (MOE Email)</v-col>
                <v-col>{{ selectedStudent.moeNumber || "-" }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div class="text-center pt-1">
            <v-btn block :loading="linkApi.isLoading" rounded color="primary" dark @click="link()">
              Confirm
            </v-btn>
          </div>
          <div class="text-center pt-2">
            <v-btn block rounded outlined color="primary" dark @click="back">
              Back
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import TextField from "../../components/Form/TextField.vue";
export default {
  components: {
    TextField,
  },

  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    step: 1,
    institution: null,
    valid: true,
    name: null,
    mainInstitution: null,
    mainClassroom: null,
    moeNumber: null,
    id: null,
    students: [],
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    playerApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    editApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    linkApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    mochiId: null,
    selectedStudentId: null,
    selectedStudent: {},
    student: {}
  }),
  computed: {

  },
  created() {
    this.api.method = "GET";
    this.api.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/institution/" +
      this.$route.params.grandparentId +
      "/classroom/" +
      this.$route.params.parentId +
      "/student/" +
      this.$route.params.id;

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = (resp) => {
      this.student = resp
      this.student.Institution = resp.Classroom.Institution;
      this.api.isLoading = false;
      this.name = resp.name;
      this.isActive = resp.isActive;
      this.mochiId = resp.mochiId;
      this.moeNumber = resp.moeNumber;
      this.mainInstitution = resp.mainInstitution;
      this.mainClassroom = resp.mainClassroom;
      this.institution = resp.Classroom.Institution;
      this.updateBreadcrumb(resp);
    };

    //EOC
    this.playerApi.method = "GET";
    this.playerApi.url =
      this.$api.servers.game + "/api/v1/" + this.$_getLocale() + "/data/player";

    this.playerApi.callbackReset = () => {
      this.playerApi.isLoading = true;
      this.playerApi.isError = false;
    };

    this.playerApi.callbackError = (e) => {
      this.playerApi.isLoading = false;
      this.playerApi.isError = true;
      this.playerApi.error = e;
    };

    this.playerApi.callbackSuccess = (resp) => {
      this.playerApi.isLoading = false;
      resp.push({
        id: null,
        mochiId: "Select One",
      });
      this.selectField.options = resp.reverse();
    };
    this.editApi.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/classroom/" +
      this.$route.params.parentId +
      "/student/search";

    this.editApi.callbackReset = () => {
      this.editApi.isLoading = true;
      this.editApi.isError = false;
    };

    this.editApi.callbackError = (e) => {
      this.editApi.isLoading = false;
      this.editApi.isError = true;
      this.editApi.error = e;
    };

    this.editApi.callbackSuccess = (resp) => {
      this.editApi.isLoading = false;
      this.students = resp;
      this.selectedStudentId = resp[0].id;
      this.step++;
      console.log(this.students);
      // this.$router.push({ name: 'PageEducatorInstitutionClassroomStudentRead', params: {
      //   id:this.$route.params.id,
      //   parentId:  this.$route.params.parentId,
      //   grandparentId:  this.$route.params.grandparentId,
      // } });
    };
    this.linkApi.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/classroom/" +
      this.$route.params.parentId +
      "/student/link";

    this.linkApi.callbackReset = () => {
      this.linkApi.isLoading = true;
      this.linkApi.isError = false;
    };

    this.linkApi.callbackError = (e) => {
      this.linkApi.isLoading = false;
      this.linkApi.isError = true;
      this.linkApi.error = e;
    };

    this.linkApi.callbackSuccess = () => {
      this.linkApi.isLoading = false;
      this.$router.push({
        name: 'PageEducatorInstitutionClassroomStudentRead', params: {
          id: this.$route.params.id,
          parentId: this.$route.params.parentId,
          grandparentId: this.$route.params.grandparentId,
        }
      });
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.$api.fetch(this.api);
    this.$api.fetch(this.playerApi);
  },
  watch: {
    name: function () {
      this.nameRules = [];
    },
  },
  methods: {
    updateBreadcrumb(resp) {
      this.breadcrumbs.push({
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      });
      this.breadcrumbs.push({
        text: resp.Classroom.Institution.name,
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.grandparentId },
        },
        exact: true,
      });
      this.breadcrumbs.push({
        text: "Classrooms",
        to: {
          name: "PageEducatorInstitutionClassroom",
          params: { id: this.$route.params.grandparentId },
        },
        exact: true,
      });
      this.breadcrumbs.push({
        text: resp.Classroom.name,
        to: {
          name: "PageEducatorInstitutionClassroomDashboard",
          params: {
            id: this.$route.params.parentId,
            parentId: this.$route.params.grandparentId,
          },
        },
        exact: true,
      });

      this.breadcrumbs.push({
        text: "Students",
        to: {
          name: "PageEducatorInstitutionClassroomStudent",
          params: {
            id: this.$route.params.parentId,
            parentId: this.$route.params.grandparentId,
          },
        },
        exact: true,
      });
      this.breadcrumbs.push({
        text: resp.name,
        to: {
          name: "PageEducatorInstitutionClassroomStudentRead",
          params: {
            id: this.$route.params.id,
            parentId: this.$route.params.parentId,
            grandparentId: this.$route.params.grandparentId,
          },
        },
        exact: true,
      });

      this.breadcrumbs.push({
        text: "Link",
        to: { name: "PageEducatorInstitutionClassroomStudentLink" },
        exact: true,
      });
    },
    close() {
      this.$router.push({
        name: "PageEducatorInstitutionClassroomStudent",
        params: {
          parentId: this.$route.params.grandparentId,
          id: this.$route.params.parentId,
        },
      });
    },
    next() {
      console.log(this.selectedStudentId)
      this.selectedStudent = this.students.find(s => s.id == this.selectedStudentId)
      console.log(this.selectedStudent)
      this.step++;
    },
    back() {
      this.step--;
    },
    search() {
      this.nameRules = [(v) => !!v || "Name is required"];
      let self = this;
      setTimeout(function () {
        if (self.$refs.formName.validate()) {
          self.editApi.params = {
            id: self.id,
            name: self.name,
            moeNumber: self.moeNumber,
            mainClassroom: self.mainClassroom,
            mainInstitution: self.mainInstitution,
          };
          self.$api.fetch(self.editApi);
        } else {
          self.editApi.callbackError("Please check the form.");
        }
      });
    },
    link() {
      this.linkApi.params = {
        id: this.id,
        selectedStudentId: this.selectedStudentId,
        moeNumber: this.moeNumber,
        mainClassroom: this.mainClassroom,
        mainInstitution: this.mainInstitution,
      };
      this.$api.fetch(this.linkApi);
    },
    selectUserType(item) {
      this.mochiId = item.value;
    },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}

.form-content {
  width: 300px !important;
}
</style>